"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../../elements/course/Header/constants");
const font_1 = require("../../font");
const theme_1 = require("../../theme");
const genStyle_1 = require("../genStyle");
const styleSchema = {
    panel: {
        showHeader: (0, genStyle_1.genStyle)({ value: true }),
        showLogo: (0, genStyle_1.genStyle)({ value: true }),
        backgroundColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.primaryBackgroundColor }),
    },
    menu: {
        showMenu: (0, genStyle_1.genStyle)({ value: true }),
    },
    icon: {
        color: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.primaryTextColor }),
    },
    disabled: {
        color: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.inactiveColor }),
    },
    burgerIcon: {
        backgroundImage: (0, genStyle_1.genStyle)({ value: null }),
    },
    crossIcon: {
        backgroundImage: (0, genStyle_1.genStyle)({ value: null }),
    },
    hover: {
        color: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.focusedColor }),
    },
    border: {
        borderStyle: (0, genStyle_1.genStyle)({ value: 'solid' }),
        borderWidth: (0, genStyle_1.genStyle)({ value: 1 }),
        borderColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.borderColor }),
        borderRadius: (0, genStyle_1.genStyle)({ value: 0 }),
    },
    effects: {
        boxShadow: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.boxShadow }),
    },
};
const fontSchema = {
    base: Object.assign({}, font_1.FONT_SCHEMA_EMPTY.base),
};
exports.default = { [constants_1.TYPE]: { style: styleSchema, font: fontSchema, feedback: {} } };
